import React from 'react';
import {toast} from "react-toastify";
import copyTitleToClipboard from "../../../utils/copyText";

const ContactCard = ({contact}) => {
    const {imageBase64, imageTag, email, descriptionEn} = contact;
    const handleClick = (e) => {
        const result = copyTitleToClipboard(e.target.textContent);
        result ? toast.success('Email Copied To Clipboard!', {theme: "colored"}) : toast.error('Could Not Copy The Text!');
    }
    return (
        <div className="custom-card">
            <div className="left">
                <img src={`data:image/jpg;base64,${imageBase64}`} alt={imageTag}/>
            </div>
            <div className="right">
                <p className='mt-3 mb-0'>{descriptionEn}</p>
                <button className="copy-email-btn" onClick={handleClick} type="button">
                    {/*<a href={`mailto:${email}`} className="copy-email-btn" type="button">*/}
                    {email}
                    {/*</a>*/}
                </button>
                <span className="tooltipText"> Click to copy the email </span>
            </div>
        </div>
    );
};

export default ContactCard;
